@file:OptIn(InternalResourceApi::class)

package gero.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/gero.composeapp.generated.resources/"

@delegate:ResourceContentHash(-1_656_311_267)
internal val Res.string.changelog_15_0_3_item_3: StringResource by lazy {
      StringResource("string:changelog_15_0_3_item_3", "changelog_15_0_3_item_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 7170, 147),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7434, 163),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7730, 171),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 7182, 139),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6722, 139),
      ))
    }

@delegate:ResourceContentHash(2_028_004_566)
internal val Res.string.changelog_15_0_3_item_4: StringResource by lazy {
      StringResource("string:changelog_15_0_3_item_4", "changelog_15_0_3_item_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 7318, 147),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7598, 143),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7902, 143),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 7322, 131),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6862, 119),
      ))
    }

@delegate:ResourceContentHash(-131_800_307)
internal val Res.string.changelog_15_0_3_item_5: StringResource by lazy {
      StringResource("string:changelog_15_0_3_item_5", "changelog_15_0_3_item_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 7466, 107),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7742, 111),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8046, 115),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 7454, 103),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6982, 99),
      ))
    }

@delegate:ResourceContentHash(-1_166_933_281)
internal val Res.string.changelog_15_0_3_item_6: StringResource by lazy {
      StringResource("string:changelog_15_0_3_item_6", "changelog_15_0_3_item_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 7574, 131),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7854, 143),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8162, 143),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 7558, 135),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7082, 115),
      ))
    }

@delegate:ResourceContentHash(888_408_900)
internal val Res.string.changelog_15_0_3_item_7: StringResource by lazy {
      StringResource("string:changelog_15_0_3_item_7", "changelog_15_0_3_item_7", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 7706, 151),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7998, 147),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8306, 171),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 7694, 131),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7198, 131),
      ))
    }

@delegate:ResourceContentHash(1_391_536_239)
internal val Res.string.changelog_16_0_0_item_1: StringResource by lazy {
      StringResource("string:changelog_16_0_0_item_1", "changelog_16_0_0_item_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 7858, 119),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8146, 119),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8478, 123),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 7826, 115),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7330, 119),
      ))
    }

@delegate:ResourceContentHash(-492_097_691)
internal val Res.string.changelog_16_0_0_item_2: StringResource by lazy {
      StringResource("string:changelog_16_0_0_item_2", "changelog_16_0_0_item_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 7978, 155),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8266, 139),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8602, 139),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 7942, 123),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7450, 147),
      ))
    }

@delegate:ResourceContentHash(998_632_235)
internal val Res.string.changelog_16_0_0_item_3: StringResource by lazy {
      StringResource("string:changelog_16_0_0_item_3", "changelog_16_0_0_item_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 8134, 111),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8406, 111),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8742, 99),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 8066, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7598, 95),
      ))
    }

@delegate:ResourceContentHash(-242_280_937)
internal val Res.string.changelog_16_0_0_item_4: StringResource by lazy {
      StringResource("string:changelog_16_0_0_item_4", "changelog_16_0_0_item_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 8246, 91),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8518, 131),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8842, 119),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 8162, 111),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7694, 95),
      ))
    }

@delegate:ResourceContentHash(598_873_329)
internal val Res.string.changelog_16_0_1_item_1: StringResource by lazy {
      StringResource("string:changelog_16_0_1_item_1", "changelog_16_0_1_item_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 8338, 139),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8650, 159),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8962, 163),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 8274, 155),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7790, 127),
      ))
    }

@delegate:ResourceContentHash(-1_394_623_594)
internal val Res.string.changelog_16_0_1_item_2: StringResource by lazy {
      StringResource("string:changelog_16_0_1_item_2", "changelog_16_0_1_item_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 8478, 127),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8810, 147),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9126, 147),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 8430, 123),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7918, 115),
      ))
    }

@delegate:ResourceContentHash(-1_395_485_355)
internal val Res.string.changelog_16_0_1_item_3: StringResource by lazy {
      StringResource("string:changelog_16_0_1_item_3", "changelog_16_0_1_item_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 8606, 123),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8958, 147),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9274, 151),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 8554, 135),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8034, 115),
      ))
    }

@delegate:ResourceContentHash(1_709_047_654)
internal val Res.string.changelog_16_0_1_item_4: StringResource by lazy {
      StringResource("string:changelog_16_0_1_item_4", "changelog_16_0_1_item_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 8730, 107),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9106, 119),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9426, 127),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 8690, 115),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8150, 103),
      ))
    }

@delegate:ResourceContentHash(-1_970_943_071)
internal val Res.string.changelog_1_11_10_item_1: StringResource by lazy {
      StringResource("string:changelog_1_11_10_item_1", "changelog_1_11_10_item_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 8838, 108),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9226, 108),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9554, 108),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 8806, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8254, 92),
      ))
    }

@delegate:ResourceContentHash(-480_367_020)
internal val Res.string.changelog_1_11_10_item_2: StringResource by lazy {
      StringResource("string:changelog_1_11_10_item_2", "changelog_1_11_10_item_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 8947, 116),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9335, 112),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9663, 124),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 8915, 100),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8347, 108),
      ))
    }

@delegate:ResourceContentHash(-1_773_438_019)
internal val Res.string.changelog_1_11_11_item_1: StringResource by lazy {
      StringResource("string:changelog_1_11_11_item_1", "changelog_1_11_11_item_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 9064, 148),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9448, 152),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9788, 132),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 9016, 136),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8456, 124),
      ))
    }

@delegate:ResourceContentHash(-200_199_204)
internal val Res.string.changelog_1_11_11_item_2: StringResource by lazy {
      StringResource("string:changelog_1_11_11_item_2", "changelog_1_11_11_item_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 9213, 80),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9601, 84),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9921, 80),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 9153, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8581, 72),
      ))
    }

@delegate:ResourceContentHash(-93_677_729)
internal val Res.string.changelog_1_11_11_item_3: StringResource by lazy {
      StringResource("string:changelog_1_11_11_item_3", "changelog_1_11_11_item_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 9294, 128),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9686, 120),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10002, 136),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 9230, 112),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8654, 112),
      ))
    }

@delegate:ResourceContentHash(-804_633_567)
internal val Res.string.changelog_1_11_7_item_1: StringResource by lazy {
      StringResource("string:changelog_1_11_7_item_1", "changelog_1_11_7_item_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 9423, 83),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9807, 99),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10139, 91),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 9343, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8767, 83),
      ))
    }

@delegate:ResourceContentHash(-1_484_340_024)
internal val Res.string.changelog_1_11_7_item_2: StringResource by lazy {
      StringResource("string:changelog_1_11_7_item_2", "changelog_1_11_7_item_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 9507, 107),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9907, 111),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10231, 111),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 9435, 115),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8851, 95),
      ))
    }

@delegate:ResourceContentHash(598_425_392)
internal val Res.string.changelog_1_11_7_item_3: StringResource by lazy {
      StringResource("string:changelog_1_11_7_item_3", "changelog_1_11_7_item_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 9615, 163),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10019, 171),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10343, 155),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 9551, 159),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8947, 127),
      ))
    }

@delegate:ResourceContentHash(-2_071_097_335)
internal val Res.string.changelog_1_11_7_item_4: StringResource by lazy {
      StringResource("string:changelog_1_11_7_item_4", "changelog_1_11_7_item_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 9779, 159),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10191, 163),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10499, 163),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 9711, 151),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9075, 131),
      ))
    }

@delegate:ResourceContentHash(-1_163_835_916)
internal val Res.string.changelog_1_11_7_item_5: StringResource by lazy {
      StringResource("string:changelog_1_11_7_item_5", "changelog_1_11_7_item_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 9939, 163),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10355, 167),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10663, 167),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 9863, 151),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9207, 131),
      ))
    }

@delegate:ResourceContentHash(-1_057_993_642)
internal val Res.string.changelog_1_11_8_item_1: StringResource by lazy {
      StringResource("string:changelog_1_11_8_item_1", "changelog_1_11_8_item_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 10103, 115),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10523, 107),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10831, 119),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 10015, 107),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9339, 87),
      ))
    }

@delegate:ResourceContentHash(-885_235_373)
internal val Res.string.changelog_1_11_8_item_2: StringResource by lazy {
      StringResource("string:changelog_1_11_8_item_2", "changelog_1_11_8_item_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 10219, 127),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10631, 135),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10951, 147),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 10123, 135),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9427, 119),
      ))
    }

@delegate:ResourceContentHash(1_105_973_292)
internal val Res.string.changelog_1_11_8_item_3: StringResource by lazy {
      StringResource("string:changelog_1_11_8_item_3", "changelog_1_11_8_item_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 10347, 175),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10767, 151),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11099, 159),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 10259, 151),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9547, 139),
      ))
    }

@delegate:ResourceContentHash(1_991_846_515)
internal val Res.string.changelog_1_11_8_item_4: StringResource by lazy {
      StringResource("string:changelog_1_11_8_item_4", "changelog_1_11_8_item_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 10523, 127),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10919, 147),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11259, 147),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 10411, 123),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9687, 91),
      ))
    }

@delegate:ResourceContentHash(1_177_754_374)
internal val Res.string.changelog_1_11_9_item_1: StringResource by lazy {
      StringResource("string:changelog_1_11_9_item_1", "changelog_1_11_9_item_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 10651, 107),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 11067, 127),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11407, 131),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 10535, 119),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9779, 103),
      ))
    }

@delegate:ResourceContentHash(-2_038_191_043)
internal val Res.string.changelog_1_11_9_item_2: StringResource by lazy {
      StringResource("string:changelog_1_11_9_item_2", "changelog_1_11_9_item_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 10759, 147),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 11195, 155),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11539, 155),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 10655, 147),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9883, 135),
      ))
    }

@delegate:ResourceContentHash(2_072_237_299)
internal val Res.string.changelog_1_11_9_item_3: StringResource by lazy {
      StringResource("string:changelog_1_11_9_item_3", "changelog_1_11_9_item_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 10907, 111),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 11351, 107),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11695, 107),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 10803, 119),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10019, 99),
      ))
    }

@delegate:ResourceContentHash(-635_030_982)
internal val Res.string.changelog_1_11_9_item_4: StringResource by lazy {
      StringResource("string:changelog_1_11_9_item_4", "changelog_1_11_9_item_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 11019, 151),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 11459, 155),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11803, 167),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 10923, 147),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10119, 135),
      ))
    }

@delegate:ResourceContentHash(2_107_467_572)
internal val Res.string.changelog_1_14_1_item_1: StringResource by lazy {
      StringResource("string:changelog_1_14_1_item_1", "changelog_1_14_1_item_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 11171, 287),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 11615, 299),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11971, 307),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 11071, 283),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10255, 259),
      ))
    }

@delegate:ResourceContentHash(141_456_067)
internal val Res.string.changelog_1_14_2_item_1: StringResource by lazy {
      StringResource("string:changelog_1_14_2_item_1", "changelog_1_14_2_item_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 11459, 127),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 11915, 139),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12279, 135),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 11355, 127),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10515, 119),
      ))
    }

@delegate:ResourceContentHash(1_884_813_585)
internal val Res.string.changelog_1_14_2_item_2: StringResource by lazy {
      StringResource("string:changelog_1_14_2_item_2", "changelog_1_14_2_item_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 11587, 171),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12055, 147),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12415, 139),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 11483, 135),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10635, 127),
      ))
    }

@delegate:ResourceContentHash(547_266_980)
internal val Res.string.changelog_1_14_2_item_3: StringResource by lazy {
      StringResource("string:changelog_1_14_2_item_3", "changelog_1_14_2_item_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 11759, 135),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12203, 123),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12555, 131),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 11619, 127),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10763, 123),
      ))
    }

@delegate:ResourceContentHash(4_469_226)
internal val Res.string.changelog_1_14_2_item_4: StringResource by lazy {
      StringResource("string:changelog_1_14_2_item_4", "changelog_1_14_2_item_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 11895, 103),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12327, 119),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12687, 127),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 11747, 103),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10887, 99),
      ))
    }

@delegate:ResourceContentHash(1_214_687_960)
internal val Res.string.changelog_1_9_14_item_1: StringResource by lazy {
      StringResource("string:changelog_1_9_14_item_1", "changelog_1_9_14_item_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 11999, 159),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12447, 167),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12815, 147),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 11851, 147),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10987, 139),
      ))
    }

@delegate:ResourceContentHash(1_737_362_979)
internal val Res.string.changelog_1_9_14_item_2: StringResource by lazy {
      StringResource("string:changelog_1_9_14_item_2", "changelog_1_9_14_item_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 12159, 79),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12615, 83),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12963, 75),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 11999, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11127, 71),
      ))
    }

@delegate:ResourceContentHash(937_937_562)
internal val Res.string.changelog_1_9_14_item_3: StringResource by lazy {
      StringResource("string:changelog_1_9_14_item_3", "changelog_1_9_14_item_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 12239, 139),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12699, 135),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13039, 143),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 12075, 119),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11199, 119),
      ))
    }

@delegate:ResourceContentHash(-1_028_532_425)
internal val Res.string.changelog_1_9_14_item_4: StringResource by lazy {
      StringResource("string:changelog_1_9_14_item_4", "changelog_1_9_14_item_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 12379, 111),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12835, 119),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13183, 131),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 12195, 103),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11319, 103),
      ))
    }

@delegate:ResourceContentHash(1_329_167_722)
internal val Res.string.changelog_close: StringResource by lazy {
      StringResource("string:changelog_close", "changelog_close", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 12491, 39),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12955, 31),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13315, 31),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 12299, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11423, 31),
      ))
    }

@delegate:ResourceContentHash(-3_204_755)
internal val Res.string.changelog_full_title: StringResource by lazy {
      StringResource("string:changelog_full_title", "changelog_full_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 12531, 40),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12987, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13347, 64),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 12331, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11455, 40),
      ))
    }

@delegate:ResourceContentHash(-1_265_399_159)
internal val Res.string.changelog_got_it: StringResource by lazy {
      StringResource("string:changelog_got_it", "changelog_got_it", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 12572, 40),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13028, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13412, 36),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 12372, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11496, 32),
      ))
    }

@delegate:ResourceContentHash(-1_806_398_963)
internal val Res.string.changelog_new_sounds: StringResource by lazy {
      StringResource("string:changelog_new_sounds", "changelog_new_sounds", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 12613, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13065, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13449, 48),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 12409, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11529, 44),
      ))
    }

@delegate:ResourceContentHash(732_619_810)
internal val Res.string.changelog_send_feedback: StringResource by lazy {
      StringResource("string:changelog_send_feedback", "changelog_send_feedback", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 12658, 51),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13118, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13498, 59),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 12454, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11574, 51),
      ))
    }

@delegate:ResourceContentHash(651_509_398)
internal val Res.string.changelog_title: StringResource by lazy {
      StringResource("string:changelog_title", "changelog_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 12710, 59),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13182, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13558, 63),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 12514, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11626, 59),
      ))
    }

@delegate:ResourceContentHash(-1_102_918_196)
internal val Res.string.chapter_eight_title: StringResource by lazy {
      StringResource("string:chapter_eight_title", "chapter_eight_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 12770, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13246, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13622, 43),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 12574, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11686, 43),
      ))
    }

@delegate:ResourceContentHash(1_060_042_648)
internal val Res.string.chapter_eleven_title: StringResource by lazy {
      StringResource("string:chapter_eleven_title", "chapter_eleven_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 12814, 56),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13290, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13666, 60),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 12618, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11730, 60),
      ))
    }

@delegate:ResourceContentHash(1_410_402_375)
internal val Res.string.chapter_fifteen_title: StringResource by lazy {
      StringResource("string:chapter_fifteen_title", "chapter_fifteen_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 12871, 57),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13359, 69),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13727, 69),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 12679, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11791, 57),
      ))
    }

@delegate:ResourceContentHash(-1_461_922_174)
internal val Res.string.chapter_five: StringResource by lazy {
      StringResource("string:chapter_five", "chapter_five", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 12964, 104),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13472, 108),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13832, 104),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 12780, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11884, 92),
      ))
    }

@delegate:ResourceContentHash(716_393_938)
internal val Res.string.chapter_five_title: StringResource by lazy {
      StringResource("string:chapter_five_title", "chapter_five_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 12929, 34),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13429, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13797, 34),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 12741, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11849, 34),
      ))
    }

@delegate:ResourceContentHash(-397_176_929)
internal val Res.string.chapter_four: StringResource by lazy {
      StringResource("string:chapter_four", "chapter_four", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 13187, 100),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13707, 88),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14059, 104),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 12999, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12095, 88),
      ))
    }

@delegate:ResourceContentHash(-246_637_134)
internal val Res.string.chapter_four_title: StringResource by lazy {
      StringResource("string:chapter_four_title", "chapter_four_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 13069, 50),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13581, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13937, 46),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 12877, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11977, 42),
      ))
    }

@delegate:ResourceContentHash(1_783_051_838)
internal val Res.string.chapter_fourteen_title: StringResource by lazy {
      StringResource("string:chapter_fourteen_title", "chapter_fourteen_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 13120, 66),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13636, 70),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13984, 74),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 12928, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12020, 74),
      ))
    }

@delegate:ResourceContentHash(-1_341_712_250)
internal val Res.string.chapter_nine_title: StringResource by lazy {
      StringResource("string:chapter_nine_title", "chapter_nine_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 13288, 46),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13796, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14164, 54),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 13080, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12184, 54),
      ))
    }

@delegate:ResourceContentHash(1_344_158_425)
internal val Res.string.chapter_number_label: StringResource by lazy {
      StringResource("string:chapter_number_label", "chapter_number_label", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 13335, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13859, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14219, 48),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 13135, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12239, 44),
      ))
    }

@delegate:ResourceContentHash(-400_251_192)
internal val Res.string.chapter_one: StringResource by lazy {
      StringResource("string:chapter_one", "chapter_one", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 13422, 83),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13954, 91),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14310, 87),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 13226, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12326, 79),
      ))
    }

@delegate:ResourceContentHash(-421_884_875)
internal val Res.string.chapter_one_title: StringResource by lazy {
      StringResource("string:chapter_one_title", "chapter_one_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 13380, 41),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13908, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14268, 41),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 13184, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12284, 41),
      ))
    }

@delegate:ResourceContentHash(1_530_463_161)
internal val Res.string.chapter_seven_title: StringResource by lazy {
      StringResource("string:chapter_seven_title", "chapter_seven_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 13506, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14046, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14398, 47),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 13310, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12406, 39),
      ))
    }

@delegate:ResourceContentHash(-196_410_059)
internal val Res.string.chapter_six_title: StringResource by lazy {
      StringResource("string:chapter_six_title", "chapter_six_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 13550, 57),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14094, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14446, 57),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 13354, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12446, 57),
      ))
    }

@delegate:ResourceContentHash(-949_847_168)
internal val Res.string.chapter_sixteen_title: StringResource by lazy {
      StringResource("string:chapter_sixteen_title", "chapter_sixteen_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 13608, 61),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14152, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14504, 61),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 13412, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12504, 65),
      ))
    }

@delegate:ResourceContentHash(-778_510_674)
internal val Res.string.chapter_ten_title: StringResource by lazy {
      StringResource("string:chapter_ten_title", "chapter_ten_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 13670, 61),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14210, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14566, 49),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 13474, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12570, 45),
      ))
    }

@delegate:ResourceContentHash(1_355_570_108)
internal val Res.string.chapter_thirteen_title: StringResource by lazy {
      StringResource("string:chapter_thirteen_title", "chapter_thirteen_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 13732, 50),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14264, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14616, 50),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 13524, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12616, 46),
      ))
    }

@delegate:ResourceContentHash(-301_176_269)
internal val Res.string.chapter_three: StringResource by lazy {
      StringResource("string:chapter_three", "chapter_three", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 13827, 105),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14363, 105),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14703, 89),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 13615, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12699, 85),
      ))
    }

@delegate:ResourceContentHash(-2_062_007_962)
internal val Res.string.chapter_three_title: StringResource by lazy {
      StringResource("string:chapter_three_title", "chapter_three_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 13783, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14315, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14667, 35),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 13571, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12663, 35),
      ))
    }

@delegate:ResourceContentHash(-245_492_466)
internal val Res.string.chapter_title_format: StringResource by lazy {
      StringResource("string:chapter_title_format", "chapter_title_format", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 13933, 52),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14469, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14793, 56),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 13709, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12785, 52),
      ))
    }

@delegate:ResourceContentHash(808_390_989)
internal val Res.string.chapter_twelve_title: StringResource by lazy {
      StringResource("string:chapter_twelve_title", "chapter_twelve_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 13986, 56),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14526, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14850, 52),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 13766, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12838, 48),
      ))
    }

@delegate:ResourceContentHash(1_939_553_665)
internal val Res.string.chapter_two: StringResource by lazy {
      StringResource("string:chapter_two", "chapter_two", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 14093, 87),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14637, 95),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14949, 95),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 13865, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12929, 71),
      ))
    }

@delegate:ResourceContentHash(1_007_143_664)
internal val Res.string.chapter_two_title: StringResource by lazy {
      StringResource("string:chapter_two_title", "chapter_two_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 14043, 49),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14587, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14903, 45),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 13819, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12887, 41),
      ))
    }

@delegate:ResourceContentHash(326_414_474)
internal val Res.string.character_locked_hint: StringResource by lazy {
      StringResource("string:character_locked_hint", "character_locked_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 14181, 117),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14733, 113),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15045, 101),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 13949, 105),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13001, 97),
      ))
    }

@delegate:ResourceContentHash(1_329_167_722)
internal val Res.string.chiudi_btn: StringResource by lazy {
      StringResource("string:chiudi_btn", "chiudi_btn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 14299, 34),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14847, 26),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15147, 26),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 14055, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13099, 26),
      ))
    }

@delegate:ResourceContentHash(715_042_001)
internal val Res.string.clear_input_desc: StringResource by lazy {
      StringResource("string:clear_input_desc", "clear_input_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 14334, 48),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14874, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15174, 48),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 14082, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13126, 40),
      ))
    }

@delegate:ResourceContentHash(1_735_575_573)
internal val Res.string.clear_search_desc: StringResource by lazy {
      StringResource("string:clear_search_desc", "clear_search_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 14383, 45),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14915, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15223, 53),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 14127, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13167, 41),
      ))
    }

@delegate:ResourceContentHash(-1_082_892_448)
internal val Res.string.clear_wrong_answers_btn: StringResource by lazy {
      StringResource("string:clear_wrong_answers_btn", "clear_wrong_answers_btn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 14429, 63),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14965, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15277, 67),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 14177, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13209, 63),
      ))
    }

@delegate:ResourceContentHash(-110_611_944)
internal val Res.string.cloud_save_desc: StringResource by lazy {
      StringResource("string:cloud_save_desc", "cloud_save_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 14493, 107),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15029, 131),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15345, 103),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 14241, 135),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13273, 99),
      ))
    }

@delegate:ResourceContentHash(1_610_289_672)
internal val Res.string.cloud_save_title: StringResource by lazy {
      StringResource("string:cloud_save_title", "cloud_save_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 14601, 72),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15161, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15449, 72),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 14377, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13373, 48),
      ))
    }

@delegate:ResourceContentHash(-82_252_021)
internal val Res.string.combo_coins_bonus: StringResource by lazy {
      StringResource("string:combo_coins_bonus", "combo_coins_bonus", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 14674, 41),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15210, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15522, 41),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 14426, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13422, 41),
      ))
    }

@delegate:ResourceContentHash(1_098_164_902)
internal val Res.string.combo_feedback: StringResource by lazy {
      StringResource("string:combo_feedback", "combo_feedback", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 14716, 54),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15252, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15564, 66),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 14468, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13464, 54),
      ))
    }

@delegate:ResourceContentHash(-901_314_844)
internal val Res.string.combo_subtitle_5_correct: StringResource by lazy {
      StringResource("string:combo_subtitle_5_correct", "combo_subtitle_5_correct", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 14771, 72),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15303, 76),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15631, 68),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 14519, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13519, 68),
      ))
    }

@delegate:ResourceContentHash(-834_066_849)
internal val Res.string.combo_title: StringResource by lazy {
      StringResource("string:combo_title", "combo_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 14844, 31),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15380, 35),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15700, 31),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 14588, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13588, 31),
      ))
    }

@delegate:ResourceContentHash(-797_833_143)
internal val Res.string.common_or: StringResource by lazy {
      StringResource("string:common_or", "common_or", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 14876, 25),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15416, 21),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15732, 21),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 14620, 25),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13620, 21),
      ))
    }

@delegate:ResourceContentHash(1_374_310_188)
internal val Res.string.conferma_btn: StringResource by lazy {
      StringResource("string:conferma_btn", "conferma_btn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 14902, 36),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15438, 32),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15754, 32),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 14646, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13642, 32),
      ))
    }

@delegate:ResourceContentHash(-1_135_699_253)
internal val Res.string.confirm_password_label: StringResource by lazy {
      StringResource("string:confirm_password_label", "confirm_password_label", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 14939, 58),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15471, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15787, 66),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 14679, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13675, 54),
      ))
    }

@delegate:ResourceContentHash(471_084_410)
internal val Res.string.continua_btn: StringResource by lazy {
      StringResource("string:continua_btn", "continua_btn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 14998, 36),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15530, 32),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15854, 32),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 14734, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13730, 32),
      ))
    }

@delegate:ResourceContentHash(1_925_636_406)
internal val Res.string.correct_answer_prefix: StringResource by lazy {
      StringResource("string:correct_answer_prefix", "correct_answer_prefix", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 15035, 61),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15563, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15887, 57),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 14767, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13763, 57),
      ))
    }

@delegate:ResourceContentHash(-155_459_021)
internal val Res.string.correct_feedback_1: StringResource by lazy {
      StringResource("string:correct_feedback_1", "correct_feedback_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 15097, 42),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15625, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15945, 54),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 14829, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13821, 42),
      ))
    }

@delegate:ResourceContentHash(468_539_642)
internal val Res.string.correct_feedback_2: StringResource by lazy {
      StringResource("string:correct_feedback_2", "correct_feedback_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 15140, 42),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15672, 38),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16000, 38),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 14872, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13864, 34),
      ))
    }

@delegate:ResourceContentHash(533_063_754)
internal val Res.string.correct_feedback_3: StringResource by lazy {
      StringResource("string:correct_feedback_3", "correct_feedback_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 15183, 38),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15711, 38),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16039, 38),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 14911, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13899, 38),
      ))
    }

@delegate:ResourceContentHash(1_176_784_633)
internal val Res.string.create_account_title: StringResource by lazy {
      StringResource("string:create_account_title", "create_account_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 15222, 48),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15750, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16078, 52),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 14950, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13938, 52),
      ))
    }

@delegate:ResourceContentHash(-218_913_462)
internal val Res.string.cta_complete: StringResource by lazy {
      StringResource("string:cta_complete", "cta_complete", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 15304, 104),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15840, 124),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16168, 128),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 15032, 100),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14020, 96),
      ))
    }

@delegate:ResourceContentHash(1_539_176_857)
internal val Res.string.cta_complete_btn: StringResource by lazy {
      StringResource("string:cta_complete_btn", "cta_complete_btn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 15271, 32),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15803, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16131, 36),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 14999, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13991, 28),
      ))
    }

@delegate:ResourceContentHash(1_065_271_415)
internal val Res.string.cta_restore: StringResource by lazy {
      StringResource("string:cta_restore", "cta_restore", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 15457, 59),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16001, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16333, 67),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 15173, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14153, 67),
      ))
    }

@delegate:ResourceContentHash(-1_584_408_668)
internal val Res.string.cta_restore_btn: StringResource by lazy {
      StringResource("string:cta_restore_btn", "cta_restore_btn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 15409, 47),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15965, 35),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16297, 35),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 15133, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14117, 35),
      ))
    }

@delegate:ResourceContentHash(-1_409_270_485)
internal val Res.string.custom_glasses_locked_desc: StringResource by lazy {
      StringResource("string:custom_glasses_locked_desc", "custom_glasses_locked_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 15517, 218),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16057, 230),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16401, 238),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 15229, 214),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14221, 182),
      ))
    }

@delegate:ResourceContentHash(298_343_828)
internal val Res.string.custom_glasses_locked_title: StringResource by lazy {
      StringResource("string:custom_glasses_locked_title", "custom_glasses_locked_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 15736, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16288, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16640, 67),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 15444, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14404, 55),
      ))
    }

@delegate:ResourceContentHash(-1_520_306_613)
internal val Res.string.custom_glasses_type_base: StringResource by lazy {
      StringResource("string:custom_glasses_type_base", "custom_glasses_type_base", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 15792, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16348, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16708, 44),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 15504, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14460, 44),
      ))
    }

@delegate:ResourceContentHash(-1_742_772_727)
internal val Res.string.custom_glasses_type_ciclope: StringResource by lazy {
      StringResource("string:custom_glasses_type_ciclope", "custom_glasses_type_ciclope", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 15837, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16393, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16753, 47),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 15549, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14505, 47),
      ))
    }

@delegate:ResourceContentHash(980_517_599)
internal val Res.string.custom_glasses_type_gold: StringResource by lazy {
      StringResource("string:custom_glasses_type_gold", "custom_glasses_type_gold", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 15881, 40),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16441, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16801, 36),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 15597, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14553, 40),
      ))
    }

@delegate:ResourceContentHash(1_759_890_877)
internal val Res.string.custom_glasses_type_pixel: StringResource by lazy {
      StringResource("string:custom_glasses_type_pixel", "custom_glasses_type_pixel", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 15922, 41),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16478, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16838, 41),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 15634, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14594, 41),
      ))
    }

@delegate:ResourceContentHash(-635_475_764)
internal val Res.string.custom_hat_locked_caption: StringResource by lazy {
      StringResource("string:custom_hat_locked_caption", "custom_hat_locked_caption", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 15964, 61),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16520, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16880, 57),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 15676, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14636, 57),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString1Resources(map: MutableMap<String, StringResource>) {
  map.put("changelog_15_0_3_item_3", Res.string.changelog_15_0_3_item_3)
  map.put("changelog_15_0_3_item_4", Res.string.changelog_15_0_3_item_4)
  map.put("changelog_15_0_3_item_5", Res.string.changelog_15_0_3_item_5)
  map.put("changelog_15_0_3_item_6", Res.string.changelog_15_0_3_item_6)
  map.put("changelog_15_0_3_item_7", Res.string.changelog_15_0_3_item_7)
  map.put("changelog_16_0_0_item_1", Res.string.changelog_16_0_0_item_1)
  map.put("changelog_16_0_0_item_2", Res.string.changelog_16_0_0_item_2)
  map.put("changelog_16_0_0_item_3", Res.string.changelog_16_0_0_item_3)
  map.put("changelog_16_0_0_item_4", Res.string.changelog_16_0_0_item_4)
  map.put("changelog_16_0_1_item_1", Res.string.changelog_16_0_1_item_1)
  map.put("changelog_16_0_1_item_2", Res.string.changelog_16_0_1_item_2)
  map.put("changelog_16_0_1_item_3", Res.string.changelog_16_0_1_item_3)
  map.put("changelog_16_0_1_item_4", Res.string.changelog_16_0_1_item_4)
  map.put("changelog_1_11_10_item_1", Res.string.changelog_1_11_10_item_1)
  map.put("changelog_1_11_10_item_2", Res.string.changelog_1_11_10_item_2)
  map.put("changelog_1_11_11_item_1", Res.string.changelog_1_11_11_item_1)
  map.put("changelog_1_11_11_item_2", Res.string.changelog_1_11_11_item_2)
  map.put("changelog_1_11_11_item_3", Res.string.changelog_1_11_11_item_3)
  map.put("changelog_1_11_7_item_1", Res.string.changelog_1_11_7_item_1)
  map.put("changelog_1_11_7_item_2", Res.string.changelog_1_11_7_item_2)
  map.put("changelog_1_11_7_item_3", Res.string.changelog_1_11_7_item_3)
  map.put("changelog_1_11_7_item_4", Res.string.changelog_1_11_7_item_4)
  map.put("changelog_1_11_7_item_5", Res.string.changelog_1_11_7_item_5)
  map.put("changelog_1_11_8_item_1", Res.string.changelog_1_11_8_item_1)
  map.put("changelog_1_11_8_item_2", Res.string.changelog_1_11_8_item_2)
  map.put("changelog_1_11_8_item_3", Res.string.changelog_1_11_8_item_3)
  map.put("changelog_1_11_8_item_4", Res.string.changelog_1_11_8_item_4)
  map.put("changelog_1_11_9_item_1", Res.string.changelog_1_11_9_item_1)
  map.put("changelog_1_11_9_item_2", Res.string.changelog_1_11_9_item_2)
  map.put("changelog_1_11_9_item_3", Res.string.changelog_1_11_9_item_3)
  map.put("changelog_1_11_9_item_4", Res.string.changelog_1_11_9_item_4)
  map.put("changelog_1_14_1_item_1", Res.string.changelog_1_14_1_item_1)
  map.put("changelog_1_14_2_item_1", Res.string.changelog_1_14_2_item_1)
  map.put("changelog_1_14_2_item_2", Res.string.changelog_1_14_2_item_2)
  map.put("changelog_1_14_2_item_3", Res.string.changelog_1_14_2_item_3)
  map.put("changelog_1_14_2_item_4", Res.string.changelog_1_14_2_item_4)
  map.put("changelog_1_9_14_item_1", Res.string.changelog_1_9_14_item_1)
  map.put("changelog_1_9_14_item_2", Res.string.changelog_1_9_14_item_2)
  map.put("changelog_1_9_14_item_3", Res.string.changelog_1_9_14_item_3)
  map.put("changelog_1_9_14_item_4", Res.string.changelog_1_9_14_item_4)
  map.put("changelog_close", Res.string.changelog_close)
  map.put("changelog_full_title", Res.string.changelog_full_title)
  map.put("changelog_got_it", Res.string.changelog_got_it)
  map.put("changelog_new_sounds", Res.string.changelog_new_sounds)
  map.put("changelog_send_feedback", Res.string.changelog_send_feedback)
  map.put("changelog_title", Res.string.changelog_title)
  map.put("chapter_eight_title", Res.string.chapter_eight_title)
  map.put("chapter_eleven_title", Res.string.chapter_eleven_title)
  map.put("chapter_fifteen_title", Res.string.chapter_fifteen_title)
  map.put("chapter_five", Res.string.chapter_five)
  map.put("chapter_five_title", Res.string.chapter_five_title)
  map.put("chapter_four", Res.string.chapter_four)
  map.put("chapter_four_title", Res.string.chapter_four_title)
  map.put("chapter_fourteen_title", Res.string.chapter_fourteen_title)
  map.put("chapter_nine_title", Res.string.chapter_nine_title)
  map.put("chapter_number_label", Res.string.chapter_number_label)
  map.put("chapter_one", Res.string.chapter_one)
  map.put("chapter_one_title", Res.string.chapter_one_title)
  map.put("chapter_seven_title", Res.string.chapter_seven_title)
  map.put("chapter_six_title", Res.string.chapter_six_title)
  map.put("chapter_sixteen_title", Res.string.chapter_sixteen_title)
  map.put("chapter_ten_title", Res.string.chapter_ten_title)
  map.put("chapter_thirteen_title", Res.string.chapter_thirteen_title)
  map.put("chapter_three", Res.string.chapter_three)
  map.put("chapter_three_title", Res.string.chapter_three_title)
  map.put("chapter_title_format", Res.string.chapter_title_format)
  map.put("chapter_twelve_title", Res.string.chapter_twelve_title)
  map.put("chapter_two", Res.string.chapter_two)
  map.put("chapter_two_title", Res.string.chapter_two_title)
  map.put("character_locked_hint", Res.string.character_locked_hint)
  map.put("chiudi_btn", Res.string.chiudi_btn)
  map.put("clear_input_desc", Res.string.clear_input_desc)
  map.put("clear_search_desc", Res.string.clear_search_desc)
  map.put("clear_wrong_answers_btn", Res.string.clear_wrong_answers_btn)
  map.put("cloud_save_desc", Res.string.cloud_save_desc)
  map.put("cloud_save_title", Res.string.cloud_save_title)
  map.put("combo_coins_bonus", Res.string.combo_coins_bonus)
  map.put("combo_feedback", Res.string.combo_feedback)
  map.put("combo_subtitle_5_correct", Res.string.combo_subtitle_5_correct)
  map.put("combo_title", Res.string.combo_title)
  map.put("common_or", Res.string.common_or)
  map.put("conferma_btn", Res.string.conferma_btn)
  map.put("confirm_password_label", Res.string.confirm_password_label)
  map.put("continua_btn", Res.string.continua_btn)
  map.put("correct_answer_prefix", Res.string.correct_answer_prefix)
  map.put("correct_feedback_1", Res.string.correct_feedback_1)
  map.put("correct_feedback_2", Res.string.correct_feedback_2)
  map.put("correct_feedback_3", Res.string.correct_feedback_3)
  map.put("create_account_title", Res.string.create_account_title)
  map.put("cta_complete", Res.string.cta_complete)
  map.put("cta_complete_btn", Res.string.cta_complete_btn)
  map.put("cta_restore", Res.string.cta_restore)
  map.put("cta_restore_btn", Res.string.cta_restore_btn)
  map.put("custom_glasses_locked_desc", Res.string.custom_glasses_locked_desc)
  map.put("custom_glasses_locked_title", Res.string.custom_glasses_locked_title)
  map.put("custom_glasses_type_base", Res.string.custom_glasses_type_base)
  map.put("custom_glasses_type_ciclope", Res.string.custom_glasses_type_ciclope)
  map.put("custom_glasses_type_gold", Res.string.custom_glasses_type_gold)
  map.put("custom_glasses_type_pixel", Res.string.custom_glasses_type_pixel)
  map.put("custom_hat_locked_caption", Res.string.custom_hat_locked_caption)
}
